<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2021-12-15 17:59:32
 * @FilePath: /teacher-h5/src/demo/modal.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div>
      <h1 class="text-h32 mb-20">
        Modal 对话框
      </h1>
      <h4>注意事项：如果没有title，有关闭icon，title传空格：</h4>
      <div class="mb20">
        <a-button type="primary" @click="showModal">
          默认
        </a-button>
        <a-modal v-model="visible" title="title" on-ok="handleOk" centered>
          <!-- <template slot="closeIcon">
            <i class="iconfont icon-close" />
          </template> -->
          <template slot="footer">
            <a-button key="back" @click="handleCancel">
              Return
            </a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
              Submit
            </a-button>
          </template>
          <p>Some contents...</p>
          <!-- <p>Some contents...</p>
          <p>Some contents...</p>
          <p>Some contents...</p>
          <p>Some contents...</p> -->
        </a-modal>
      </div>
      <div class="mb20">
        <a-button @click="showConfirm">
          Confirm
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      visible: false
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk(e) {
      this.loading = true
      setTimeout(() => {
        this.visible = false
        this.loading = false
      }, 3000)
    },
    handleCancel(e) {
      this.visible = false
    },
    showConfirm() {
      this.$confirm({
        // title: '确认结束学习任务吗？',
        content: '确认将章小美的数学体验卡激活吗？',
        centered: true,
        onOk() {
          console.log('OK')
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'test'
      })
    }
  }
}
</script>

<style>
.mb20 {
  margin-bottom: 20px;
}
</style>